export const ITEMS_PER_PAGE = 12
export const USE_EXCLUSIVE_FILTER = true

export const DEFAULT_RESULTS_SORT_OPTION = "default"

export const BUSINESS_TYPES_FILTER_VALUES = ["large", "startup", "sme", "ngo_public_lab", "collective"]

export const DOMAINS_FILTER_VALUES = {
  auditConsultancyLegal: {
    keys: ["audit", "consultancy", "law", "managementConsultancy", "accountingServices"],
    order: 1,
  },
  bankingFinanceInsurance: { keys: ["bankingFinance", "insurance"], order: 2 },
  constructionRealEstatePlanning: { keys: ["realEstate", "buildingPlanning", "architecture"], order: 3 },
  energyEnvironmentUtilities: { keys: ["energyUtilities", "environment"], order: 5 },
  engineeringRD: { keys: ["rD", "engineering"], order: 10 },
  industrialAgribusinessChemistry: {
    keys: [
      "agribusiness",
      "aerospace",
      "automotive",
      "chemistry",
      "defense",
      "electronics",
      "materials",
      "otherIndustries",
      "agriculture",
      "maritime",
    ],
    order: 6,
  },
  itTelecoms: { keys: ["itConsultancyIt", "telecoms"], order: 7 },
  mediaDigitalPublishing: { keys: ["digitalECommerce", "mediaPublishing", "communicationAdvertising"], order: 11 },
  medicinePharmaceuticalsHealthCosmetics: { keys: ["cosmetics", "medicinePharmaceuticalsHealth"], order: 8 },
  otherCategoryGroup: { keys: ["otherCategory"], order: 14 },
  publicSocialNgoEducation: { keys: ["publicEducation", "socialNgo"], order: 12 },
  retailConsumerGoodsLuxury: { keys: ["luxury", "retail", "consumerGoods"], order: 4 },
  servicesTransport: {
    keys: ["recruitmentTraining", "catering", "transportLogistics", "otherServicesToIndividualsAndBusinesses"],
    order: 9,
  },
  tourismLeisureCulture: { keys: ["tourismHospitality", "leisureCultureSports"], order: 13 },
}
